<template>
    <input ref="colorPicker" type="text"/>
</template>

<style>
    .color-picker {
        background-color: transparent;
        border: none;
    }

    .color-picker .sp-preview {
        border-bottom-right-radius: 1.25rem;
        border-top-right-radius: 1.25rem;
        border-bottom-left-radius: 1.25rem;
        border-top-left-radius: 1.25rem;
        height: 31px !important;
        width: 35.5px !important;
    }

    .color-picker .sp-dd {
        display:none;
    }
</style>

<script>
  import 'spectrum-colorpicker/spectrum.js'
  export default {
  name: "ColorPicker",
  props: {
    organization: Object,
    value: String,
    showPalette: {
      type: Boolean,
      default: true,
    },
    palette: {
      type: Array,
      default: () => {
        return [
          // Button colors
          '#0082c2',
          '#22b24c',
          '#f57a00',
          '#d9195c',
          '#929fba',
          // Alert colors
          '#b8dcee',
          '#fcdab8',
          '#c1e9cd',
          '#fb9ebe',
          '#d0d6e2',
        ]
      },
    },
  },
  computed: {
    allColorPalette() {
      let palette = _.clone(this.palette)
      if (!!this.organization) {
        palette = this.addColorIfNotPresent(this.organization.button_color, palette)
        _.each(this.organization.brand_colors, color => {
          palette = this.addColorIfNotPresent(color, palette)
        })
      }
      palette = this.addColorIfNotPresent(this.value, palette)
      return palette
    },
  },
  methods: {
    addColorIfNotPresent(color, palette) {
      if (!!color && palette.indexOf(color) === -1) {
        palette.push(color)
      }
      return palette
    },
    initColorPicker() {
      $(this.$refs.colorPicker).spectrum({
        color: this.value || "#ffffff",
        replacerClassName: "color-picker",
        preferredFormat: "hex",
        showInput: true,
        showInitial: true,
        showButtons: false,
        showPalette: this.showPalette,
        palette: this.allColorPalette,
        move: (color) => {
          this.$emit("input", color.toHexString())
        },
      });
    },
  },
  watch: {
    value(newVal) {
      if (newVal !== $(this.$refs.colorPicker).spectrum("get").toHexString()) {
        $(this.$refs.colorPicker).spectrum("set", newVal);
      }
    },
  },
  mounted() {
    this.initColorPicker()
  },
  beforeUnmount() {
    $(this.$refs.colorPicker).spectrum("destroy")
  },
};
</script>